import { Ingredient } from "./types";
import { toNumber } from "./utils";

// These values are from Corvitto's book Secret's of Ice Cream
const HARDENING_FACTOR_WEIGHTS = {
  COCOA_SOLIDS_NONFAT: 1.8,
  COCOA_FAT: 0.9,
  VEGETABLE_FAT: 1.4,
} as const;

/**
 * Returns the hardening factor for an ingredient
 *
 * Only valid for chocolate and nuts/seeds. Uses the equation:
 *
 * HF = CacaoFat*0.9 + CacaoSolids*1.8 + OtherFat*1.4
 */
export function calculateHardeningFactor(ingredient: Ingredient) {
  if (ingredient.category !== "chocolate" && ingredient.category !== "nut") {
    return 0;
  }

  if (ingredient.category === "nut") {
    return (
      HARDENING_FACTOR_WEIGHTS.VEGETABLE_FAT *
      (ingredient.fatPct ? toNumber(ingredient.fatPct) : 0)
    );
  }

  const cocoaFatPct = toNumber(ingredient.cocoaFatPct ?? 0);
  const cocoaSolidsNonfatPct = toNumber(ingredient.cocoaSolidsNonfatPct ?? 0);

  return (
    HARDENING_FACTOR_WEIGHTS.COCOA_SOLIDS_NONFAT * cocoaSolidsNonfatPct +
    HARDENING_FACTOR_WEIGHTS.COCOA_FAT * cocoaFatPct
  );
}
